export enum EDeploymentState {
  DRAFT,
  DEPLOYING,
  DEPLOY_SUCCESS,
  DEPLOY_FAILURE,
  SDK,
  READONLY
}
